// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapButton, BootstrapIcon } from '../../../dsl/front';
import { Screen } from '../Screen';
/**
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
let ActionButton = class ActionButton extends Vue {
    constructor() {
        super(...arguments);
        /**
         * Determine if action is in progress.
         */
        this.isLoading = false;
    }
    /**
     * Determines whether there is any icon to render.
     */
    get hasIcon() {
        return typeof this.icon === 'string' && this.icon.length > 0;
    }
    /**
     * Determines whether there is any label to render.
     */
    get hasLabel() {
        return typeof this.label === 'string' && this.label.length > 0;
    }
    performAction() {
        if (!this.callback) {
            return;
        }
        const callbackReturn = this.callback();
        if (callbackReturn && typeof callbackReturn.then === 'function') {
            this.isLoading = true;
            callbackReturn.finally(() => {
                this.isLoading = false;
            });
        }
    }
};
__decorate([
    Prop({ type: Function, required: false, default: null })
], ActionButton.prototype, "callback", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ActionButton.prototype, "disabled", void 0);
__decorate([
    Prop({ type: String, required: false })
], ActionButton.prototype, "icon", void 0);
__decorate([
    Prop({ type: String, required: false })
], ActionButton.prototype, "label", void 0);
__decorate([
    Prop({ type: String, required: false })
], ActionButton.prototype, "title", void 0);
ActionButton = __decorate([
    Component({
        name: 'ActionButton',
        components: { BootstrapButton, BootstrapIcon, Screen },
        template: `
    <Screen :loading="isLoading">
      <button class="action-btn" @click="performAction" v-bind="{ disabled }" :title="title">
        <BootstrapIcon v-if="hasIcon" :name="icon" class="action-btn__icon" />
        {{ label }}
      </button>
    </Screen>
  `
    })
], ActionButton);
export { ActionButton };
export default ActionButton;
